<template>
  <div id="app" v-wechat-title="$route.meta.title">
    <pubHeaderNew ref="pubHeaderNew"></pubHeaderNew>
    <section class="hd-cont">
      <div class="hd-carousel">
        <el-carousel indicator-position="always"  arrow='always'>
          <el-carousel-item  name='carouPro'>
            <div class="hd-carousel-cont img1">
              <h3 class="hd-carousel-h3">匠心打造网络货运供应链</h3>
              <h2 class="hd-carousel-h2">务实笃行 大志有成</h2>
            </div>
          </el-carousel-item>
          <el-carousel-item  name='carouPro'>
            <div class="hd-carousel-cont img2">
              <h3 class="hd-carousel-h3">大宗商品信息发布平台 </h3>
              <h2 class="hd-carousel-h2">激昂奋进 大道易行</h2>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="hd-hall hd-hall-sour">
        <div class="hd-sour">
          <div class="hd-sour-tl clearfix">
            <h3 class="hd-sour-h3">货源信息</h3>
            <a class="hd-sour-a" target="_blank" href="/hall.html#/0">更多 ></a>
          </div>
          <ul class="hd-sour-ul clearfix">
            <li class="hd-sour-li" v-for="(item,ine) in carList" :key="ine">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>{{item.ft}}</b>
                </div>
                <div class="card_list text item">
                  <div class="card_item"> <span class="card_label">货物名称：</span> {{item.gn}} </div>
                  <div class="card_item"> <span class="card_label">装货时间：</span> {{item.lt}} </div>
                  <div class="card_item"> <span class="card_label">运输距离：</span> {{item.ml}} KM </div>
                  <!-- <div class="card_item"> <span class="card_label">货物重量：</span> {{item.on}}  </div> -->
                  <div class="card_item"> <span class="card_label">运费单价：</span> 面议 </div>
                  <div class="card_item"> <span class="card_label">联系人：</span> {{item.cn}} </div>
                  <div class="card_item"> <span class="card_label">联系电话：</span> {{item.ct}} </div>
                </div>
              </el-card>
            </li>
          </ul>
        </div>
        <div class="hd-sour">
          <div class="hd-sour-tl clearfix">
            <h3 class="hd-sour-h3">车源信息</h3>
            <a class="hd-sour-a" target="_blank" href="/hall.html#/1">更多 ></a>
          </div>
          <ul class="hd-sour-ul clearfix">
            <li class="hd-sour-li" v-for="(item,ine) in carList" :key="ine">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <b>{{item.ft}} </b>
                </div>
                <div class="card_list text item">
                  <div class="card_item"> <span class="card_label">车型/车长: </span> {{item.vl}} </div>
                  <!-- <div class="card_item"> <span class="card_label">空车时间：</span> {{item.attr_noUseTime}} </div> -->
                  <div class="card_item"> <span class="card_label">满载吨位：</span> {{item.tn}} </div>
                  <div class="card_item"> <span class="card_label">车辆牌照：</span> {{item.vn}} </div>
                  <div class="card_item"> <span class="card_label">运费单价：</span> 面议 </div>
                  <div class="card_item"> <span class="card_label">联系人：</span> {{item.dn}} </div>
                  <div class="card_item"> <span class="card_label">联系电话：</span> {{item.dt}} </div>
                  <!-- <div class="card_item"> <span class="card_label">成单次数：</span> {{item.attr_orderNum}}单 </div> -->
                </div>
              </el-card>
            </li>
          </ul>
        </div>
      </div>
      <div class="hd-hall">
        <div class="hd-sour">
          <div class="hd-sour-tl clearfix">
            <h3 class="hd-sour-h3">企业资讯</h3>
          </div>
            <div class="big-news">
              <div class="newslist clearfix" v-loading="newsStatus" ref="newslist">

                <div class="list-item"  @click="newsDetail(index,item)"  v-for="(item,index) in showList" :key="index">
                  <div class="gr-dynamic-img" :style="`background-image:url(${item.picArr})`">
                    <!-- <img :src="host+item.picArr[0].picPaths" alt="item.title"> -->
                  </div>
                  <div class="item-info">
                    <p class="news-title">{{item.title}}</p>
                    <p class="news-date">{{item.releaseDate|formatDate}}</p>
                    <div class="news-text">
                      {{item.desc}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <!-- <div class="hd-hall hd-hall-map">
        <div class="contact">
          <div class="first-title">
            <img src="../../../static/img/lianxi_women.svg" alt="">

          </div>
          <div class="mapbox clearfix">
            <div class="map fl" id="allmap">
            </div>
            <div class="address fl">
              <p class="add-label">
                <img src="../../../static/img/gongsi_dizhi.svg" alt="">
              </p>
              <div class="add-inline" style="height:90px">
                <p class="first-line clearfix"><img src="../../../static/image/ic_tomap.png" alt=""><img src="../../../static/img/dizhi1.svg" alt=""></p>
              
              </div>
              <p class="add-label">
                <img src="../../../static/img/youbian.svg" alt="">
              </p>
              <div class="add-inline">
                <p class="first-line"><img src="../../../static/image/youxiang.png" alt="">047699</p>

              </div>
              <p class="add-label">
                <img src="../../../static/img/fuwu_dianhua.svg" alt="">
              </p>
              <div class="add-inline">
                <p class="first-line"><img src="../../../static/image/dianhua.png" alt="">400-056-1156</p>
                <p></p>
              </div>
            </div>
          </div>

        </div>
      </div> -->
      <pubFooter></pubFooter>
  </section>
  </div>
</template>

<script>
import img1 from '../../../static/image/f867889d27641134eae670183ffbf242.png'
import img2 from '../../../static/image/09c919375eff9d775481df58f606b396.png'
import img3 from '../../../static/image/e63c2cbaaadd533ddbc17cede388da7c.jpg'
import img4 from '../../../static/image/d94ac5feb414df1939d6764fa3903613.png'
export default {
  name: "App",
  data() {
    return {
      isCollapse: false,
      carList:[],
      goodsList:[],
      showList:[
        {
          title:"《平顶山晚报》整版报道大易科技：智慧物流引领行业发展",
          releaseDate:1706695011000,
          desc:"1月31日，《平顶山晚报》刊发整版文章《中原大易科技有限公司：智慧物流引领行业发展》，报道大易科技推动大宗物流行业转型升级的成果。",
          picArr:img1,
          id:'25'
        },{
          title:"大易科技大宗智慧低碳物流解决方案入选“2023 物流与供应链（中国）解决方案”TOP30",
          releaseDate:1699923119000,
          desc:"作为进博会交通与物流领域重要的配套活动之一，“2023 全球贸易与国际 物流高峰论坛 ”于 11 月 8 日顺利举行，会上发布了“2023 物 流与供应链（中国）解决方案 ”TOP 30 ，大易科技大宗智慧低碳物流解决方案成功入选，是河南省唯一入选企业。",
          picArr:img2,
          id:'24'
        },{
          title:"大易荣膺2023河南企业100强第50位、服务业企业100强第13位",
          releaseDate:1698718388000,
          desc:"10月27日，“2023河南企业100强高峰会”在开封召开。会上发布了2023河南企业100强、河南制造业企业100强、河南服务业企业100强等榜单。中原大易科技有限公司名列2023河南企业100强第50位和2023河南服务业企业100强第13位，较去年排名分别上升16名和8名。",
          picArr:img3,
          id:'23'
        },{
          title:"第九届中国国际物流发展大会隆重举办 大易科技荣获全国先进物流企业奖",
          releaseDate:1698033126000,
          desc:"近日，由中国交通运输协会、国际物流与运输学会、临沂市人民政府主办的第九届中国国际物流发展大会暨中国（临沂）国际商贸物流发展会议隆重举办，大易科技受邀出席会议，并获得“2022年度全国先进物流企业”荣誉称号。",
          picArr:img4,
          id:'22'
        }
      ],
      newsStatus:false,
      carStatus:false,
      goodsStatus:false,
      host:this.API.host,
      editableTabs: [{
        // title: '全国货源信息',
        id:13
      }, {
        // title: '全国车源信息',
        channelIds: '111',
        first: 0,
        count:4,
        format:0
      }],
      news:{
        // title: '新闻',
        channelIds: '75',
        first: 0,
        count:4,
        format:0
      },
    };
  },
  methods: {
    newsDetail(id,item){
      
      // if(id=='dynamic'){
      //   location.href='/news.html#/newsDetail/133/'+item.id
      // }else{
      //   location.href='/news.html#/newsDetail/139/'+item.id
      // }
      window.open('https://www.da156.com/PC/#/NewsDetails?id='+item.id)
    },
    videoPlay(){
      
    },
    setMap(){
        // console.log(document.getElementById('allmap').clientWidth,document.getElementById('allmap').clientHeight);
        // 百度地图API功能
        var map = new BMap.Map("allmap");    // 创建Map实例
        // map.centerAndZoom(new BMap.Point(113.724459,34.768959), 12); // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(new BMap.Point(113.39695095906043,36.53139488542099), 18); // 初始化地图,设置中心点坐标和地图级别
        map.setCurrentCity("郑州");
        // map.enableScrollWheelZoom(false); // 鼠标滚动缩放
        // map.addControl(new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT}));// 左上角，添加比例尺
        // map.addControl(new BMap.NavigationControl());  //左上角，添加默认缩放平移控件
        // var myIcon = new BMap.Icon(
        //   "../../../../static/intergrated_img/images/ioc-map.png",
        //   new BMap.Size(24, 25),
        //   {
        //     anchor: new BMap.Size(12, 25) //标注图片偏移量
        //   }
        // );
        var marker = new BMap.Marker(new BMap.Point(113.39695095906043,36.53139488542099),
        // {
        //   icon: myIcon
        // }
        );
        map.addOverlay(marker); // 将标注添加到地图中
      },
    getChana(list){
      // console.log(list)
      let data = '';
      for(let i =0;i<list.length;i++){
        if(/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(list[i])){
          data = list[i]
          break
        }
      }
      return data
    },
    async getNewsData(){
      this.newsStatus= true
       let matchReg = />.*?\<\/p/gi;
      // let newsData = await this.API.line.contentList(this.news)
      
      // this.showList = !!newsData?newsData.body:[]
      // this.showList.forEach(ele=>{
      //   ele.picArr.length==0?ele.picArr[0]={}:'';
      //   let it= this.getChana(ele.txt.match(matchReg))
      //   ele.desc = ele.txt.replace(/<[^>]+>/g,"").replace(/&nbsp;/g,'')
      // })
      this.newsStatus = false
    },
    async getCarData(){
      this.carStatus = true
      let carData = await this.API.line.orderList(this.editableTabs[0])
      const entity = carData.entity || '[]'
      console.log(JSON.parse(entity))
      let carList = JSON.parse(entity)
      this.carList = carList.length>4?carList.slice(0,4):carList
      this.carList.forEach(ele=>{
        if(ele.vl.indexOf('/')==0){
          ele.vl = '牵引车'+ele.vl
        }
        ele.tn = (parseFloat(ele.tn.replace('吨',''))/1000).toFixed(2)+'吨'
        ele.ct = ele.ct.substring(0,4)+'****'+ele.ct.substring(ele.ct.length-4,ele.ct.length)
        ele.dt = ele.dt.substring(0,4)+'****'+ele.dt.substring(ele.dt.length-4,ele.dt.length)
      })
      this.carStatus = false
    },
    async getGoodsData(){
      this.goodsStatus = true
      let goodsData = await this.API.line.contentList(this.editableTabs[1])
      this.goodsList = !!goodsData?goodsData.body:[]
      this.goodsStatus = false
    },
  },
  filters: {
      // formatDate (time) {
      //     var date = new Date(time)
      //     console.log(time,formatDate(date, 'yyyy/MM/dd'))
      //     return formatDate(date, 'yyyy/MM/dd')
      // }
      formatDate(value){
          return moment(value).format('YYYY-MM-DD')
      }
  },
  mounted() {
    // gb2big5();
    // location.href='/hall.html'
    let vue = this
      setTimeout(() => {
          vue.setMap()
      }, 1000);
    this.$refs.pubHeaderNew.changeHeard(-1)
    this.getCarData()
    this.getNewsData()
    // this.getGoodsData()
    
  },
  updated() {},
  created() {}
};
</script>
<style>
.hd-cont .el-carousel__arrow--right{
  right: 50px;
}
.hd-cont .el-carousel__arrow--left{
  left: 50px;
}
.hd-cont .el-carousel__arrow{
      height: 80px;
    width: 80px;
    font-size: 54px;
    background-color: rgba(31,45,61,.2);
}
.hd-sour .el-card__header {
    border: 0;
    padding-bottom: 0;
    padding-top: 24px;
    font-size: 16px;
    font-family: MicrosoftYaHeiSemibold;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
    height: 64px;
}
</style>

<style scoped>
@import url("../../assets/reset.css");
/* @import url("../../../static/css/animate.min.css"); */
#app {
  height: 100%;
}
.filterConArea{
  height: 100%;
}
.hd-cont{
  position: relative;
  width: 100%;
  margin-top: 120px;
  background-color: #f5f5f5;
}
.hd-carousel{
  height: auto;
  width: 1260px !important;
  margin: 0 auto;
  /* background-color: #999999; */
  position: relative;
  padding-top: 30px;
}
.hd-hall{
 height: auto;
  width: 1260px !important;
  margin: 40px auto;
  /* background-color: #fff; */
  padding-top: 40px;
  /* overflow: hidden; */
  border-radius: 10px;
  
}
.hd-cont{
  background-image: url('../../../static/img/keji_bk.png');
  background-position: top;
 /* background-repeat: no-repeat; */
 background-size: auto 100% ;
}
.hd-sour{
 padding-bottom: 40px;
  position: relative;
  
}
.hd-carousel-cont{
 height: 360px;
 background-position: center;
 background-repeat: no-repeat;
 background-size: auto 100% ;
 background-color: rgba(245,245,245,1);

}
.hd-carousel-cont.img1{
  background-image: url('../../../static/img/big_img1@2x.png');
}
.hd-carousel-cont.img2{
  background-image: url('../../../static/img/big_img2@2x.png');
}
.hd-sour-ul{
  height: 325px;
  margin-top: 20px;
}
.hd-sour-li{
  width: 300px !important;
    background: rgba(255,255,255,1);
    -webkit-box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    border-radius: 8px;
    margin: 10px;
    float: left;
    height: auto;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    /* min-height: 293px; */
}
.hd-sour-li:nth-child(1){
  margin-left: 0;
}
.hd-sour-li:last-child{
  margin-right: 0;
}
.hd-sour-li .box-card{
  min-height: 300px;
  border-radius: 8px;
  overflow: hidden;
}
.hd-sour-li 
.hd-sour .box-card .card_label {
    width: 80px;
    display: inline-block;
    color: rgba(153,153,153,1);
}
.hd-sour .box-card .card_item {
    line-height: 2;
}
.hd-sour-tl{
  margin-bottom: 10px;
  position: relative;
  padding-left: 13px;
}
.hd-sour-tl .hd-sour-h3{
  /* float: left; */
  text-align: center;
  font-size: 24px;
}
.hd-sour-tl .hd-sour-a{
  display: block;
  position: absolute;
  right: 23px;
  bottom: 0;
  color: #0066ff;
  font-size: 16px;
  /* text-decoration-line: underline; */
}
.hd-sour-tl .hd-sour-a:hover{
  text-decoration-line: underline;
}
.big-news {
    width: 100%;
    margin-top: 34px;
    height: 416px;
    /* overflow: hidden; */
    position: relative;
}
.newslist {
    width: 10000%;
    /* left: 10%; */
    position: absolute;
    top: 0;
}
.list-item {
    background: #fff;
    border-radius: 8px;
    width: 300px;
    height: 400px;
    padding: 16px 16px 26px 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    float: left;
    margin-right: 20px;
    border: 4px solid transparent;
    -webkit-box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    box-shadow: 0px 10px 10px 0px rgb(0 0 0 / 3%);
    margin-bottom: 40px;
    display: block;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
.list-item:hover{
    border: 4px solid #0066FF;
  }
.gr-dynamic-img{
    width: 260px;
    overflow: hidden;
    height: 180px;
    background-position: center;
    background-size: auto 100%;
    -webkit-transition: background-size 0.3s;
    transition: background-size 0.3s;
}
.news-title {
    font-weight: bold;
    color: rgba(0,0,0,.85);
    font-size: 16px;
    line-height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 12px 0;
}
.news-date{
    font-size: 12px;
    color: #999;
    line-height: 15px;
    margin-bottom: 9px;
}
.news-text {
    font-size: 14px;
    line-height: 24px;
    color: #999;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
}
.list-item:hover .gr-dynamic-img{
  /* background-size: auto 120%; */
  /* animation: dynamicimgbig 0.3s; */
  background-size: auto 120%;
}
.contact{
    height: 90%;
    position: absolute;
    /* top: 20%; */
    width: 100%;
    /* left: 10%; */
  }
  /*.mapbox{*/
  /*  margin-top: 7%;*/
  /*  height: 80%;*/
  /*}*/
  .mapbox{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80%;
  }
  .map{
    display: block;
    width: 61.905%;
    height: 100%;
    border-radius: 10px;
    background: #6D7278;
    overflow: hidden;
    float: left;
    box-shadow: 0 10px 30px #e0e0e0;
  }
  .address{
    display: block;
    /* padding: 50px 0 0 100px; */
    /* width: 30%; */
    float: right;
    text-align: left;
  }
  .add-label{
    font-size: 16px;
    color: #333;
    line-height: 21px;
    font-weight: bold;
  }
  .add-inline{
    margin: 16px 0 32px 0;
    border-bottom: 1px solid rgba(0,0,0,.1);
    font-size: 20px;
    color: #333;
    font-weight: bold;
    line-height: 24px;
    width: 100%;
    height: 60px;
  }
  .first-line{
    font-weight: normal;
  }
  .first-line img{
    margin-right: 14px;
    /* vertical-align: middle; */
    display: block;
    float: left;
  }
  .second-line{
    text-indent: 34px;
  }
  .hd-hall-map{
    position: relative;
    height: 546px;
  }
  .first-title{
    text-align: center;
  }
  .hd-carousel-h3{
    text-align: center;
    padding-top: 100px;
    font-size: 60px;
    font-family: MicrosoftYaHeiSemibold, MicrosoftYaHeiSemibold-Regular;
    font-weight: 400;
    color: #ffffff;
    line-height: 80px;
    padding-bottom: 10px;
  }
  .hd-carousel-h2{
    text-align: center;
    font-size: 18px;
    font-family: MicrosoftYaHeiSemibold, MicrosoftYaHeiSemibold-Regular;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    border: 2px solid #ffffff;
    border-radius: 25px;
    padding: 10px 40px;
    width: 165px;
height: 24px;
    margin:0 auto;
    
  }
</style>
